const version = "3.0.0"
export default version
